export default __webpack_public_path__ + "static/roadie-racks-og-image-4528f5e877e7facba2eb64d9a1da89de.png";